import styles from './WebStartScreen.module.scss'
import { YoutubeVideos } from '../../components/youtube-videos/YoutubeVideos'
import { DesktopButton, DesktopTitleLarge } from '../../Typography'
import React, { ReactElement } from 'react'
import { NextEventData } from '../../stores/NextEventStore'
import { useNavigate } from 'react-router-dom'
import { URLS } from '../../content/urls'
import { Slideshow } from '../../components/slideshow/Slideshow'

type Props = {
  data: NextEventData[]
}

type EventViewProps = {
  data: NextEventData
}

export const WebStartScreen = ({ data }: Props): ReactElement => {
  const slides: React.ReactNode[] =
    data.length === 0
      ? [
          <div className={styles.container} key='fallback'>
            <div className={styles.backgroundImage}>
              <img
                src={URLS.startScreenPlaceholderBackground}
                alt='Bannerhintergrund zur nächsten Show'
              />
            </div>
            <div className={styles.centeredBox}>
              <img src={URLS.fightbackPlaceholderLogo} alt='Bannerlogo zur nächsten Show' />
              <DesktopTitleLarge>Ankündigungen folgen in Kürze…</DesktopTitleLarge>
            </div>
          </div>,
        ]
      : data.map((eventData, index) => <WebEventView key={index} data={eventData} />)

  return (
    <>
      <Slideshow slides={slides} />
      <YoutubeVideos />
    </>
  )
}

const WebEventView = ({ data }: EventViewProps): ReactElement => {
  const navigate = useNavigate()

  return (
    <div className={styles.container}>
      <div className={styles.backgroundImage}>
        <img src={data.eventHintergrund} alt={'Bannerhintergrund zur nächsten Show'} />
      </div>
      <div className={styles.centeredBox}>
        <img src={data.eventLogo} alt={'Bannerlogo zur nächsten Show'} />
        <div className={styles.infoBox}>
          <DesktopTitleLarge>
            {data.eventDatum} {data.eventHalle}
          </DesktopTitleLarge>
          <DesktopTitleLarge>
            Einlass: {data.eventEinlass} | Beginn: {data.eventBeginn}
          </DesktopTitleLarge>
          <div className={styles.buttonBox}>
            <div
              className={styles.matchCardButton}
              onClick={(): void => {
                navigate(data.slug)
              }}
            >
              <DesktopButton darkFont={true}>EVENT INFOS</DesktopButton>
            </div>
            {data.eventTickets.trim().length > 0 && (
              <a
                className={styles.ticketButton}
                href={data.eventTickets}
                target='_blank'
                rel='noreferrer'
              >
                <DesktopButton>TICKETS</DesktopButton>
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
